// Maps order and production statuses to color classes
export const ORDER_STATUS_STYLES = {
  'AGUARDANDO PAGAMENTO': { text: 'text-yellow-600', badge: 'bg-yellow-50', border: 'border-yellow-300' },
  'EM ANDAMENTO': { text: 'text-blue-600', badge: 'bg-blue-50', border: 'border-blue-300' },
  'PRONTO PARA COLETA': { text: 'text-purple-600', badge: 'bg-purple-50', border: 'border-purple-300' },
  'ENVIADO': { text: 'text-indigo-600', badge: 'bg-indigo-50', border: 'border-indigo-300' },
  'CONCLUÍDO': { text: 'text-green-600', badge: 'bg-green-50', border: 'border-green-300' },
  'PARCIALMENTE DEVOLVIDO': { text: 'text-orange-600', badge: 'bg-orange-50', border: 'border-orange-300' },
  'CANCELADO': { text: 'text-red-600', badge: 'bg-red-50', border: 'border-red-300' },
  'DEVOLVIDO': { text: 'text-pink-600', badge: 'bg-pink-50', border: 'border-pink-300' },
  'ESTORNADO': { text: 'text-gray-600', badge: 'bg-gray-100', border: 'border-gray-300' }
};

export const PRODUCTION_STATUS_STYLES = {
  'PENDENTE': { text: 'text-yellow-600', badge: 'bg-yellow-50', actionBg: 'bg-yellow-100 hover:bg-yellow-200' },
  'PREPARANDO': { text: 'text-blue-600', badge: 'bg-blue-50', actionBg: 'bg-blue-100 hover:bg-blue-200' },
  'PRONTO': { text: 'text-purple-600', badge: 'bg-purple-50', actionBg: 'bg-purple-100 hover:bg-purple-200' },
  // Display-only statuses for product view
  'ENTREGUE': { text: 'text-emerald-600', badge: 'bg-emerald-50', actionBg: 'bg-emerald-100' },
  'DEVOLVIDO': { text: 'text-cyan-600', badge: 'bg-cyan-50', actionBg: 'bg-cyan-100' }
};

export function getOrderStatusStyle(status) {
  return ORDER_STATUS_STYLES[status] || { text: 'text-gray-600', badge: 'bg-gray-50', border: 'border-gray-300' };
}

export function getProductionStatusStyle(status) {
  return PRODUCTION_STATUS_STYLES[status] || { text: 'text-gray-600', badge: 'bg-gray-50', actionBg: 'bg-gray-100' };
}
